import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useQuery, useClient, useMutation } from "jsonapi-react";
import Loader from "../../components/common/Loader/Loader";
import axios from "axios";
import DataTable from "react-data-table-component";
import TemplateCsv from "../../assets/files/BulkUploadTemplate.csv";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import DISPLAY_TEXTS from "../../helpers/displayTexts";
import { useHistory } from "react-router-dom";
import { API_BASE_URL, VW_ROUTES, apiRoutes } from "../../constants";
import {
  checkModuleViewPermission,
  checkModuleAddPermission,
  checkModuleDeletePermission,
  checkModuleEditPermission,
  getCategorySlug,
  getIdNumber,
  parseIdentificationType,
  checkModuleGeneralPermission,
  getCurrentWindowParams,
  getCategoryType,
  formatTextWithFallback,
  filterIdsMultiselect,
  getLocalDateTime,
  getFormattedDateTime,
} from "../../helpers/helpers";
import { AppContext } from "../../context/AppContext";
import useStorage from "../../helpers/useStorage";
import { columnData } from "./dummyColumns";
import PillText from "../../components/PillText/PillText";
import ProfileCard from "../../components/ProfileCard/ProfileCard";
import { BiSolidReport } from "react-icons/bi";
import ReactTooltip from "react-tooltip";
import useCheckProfileQuota from "../../hooks/useCheckQuota/useCheckProfileQuota";
import QuotaExceedBanner from "../../components/common/QuotaExceedBanner/QuotaExceedBanner";
import { useToasts } from "react-toast-notifications";
import { MdOutlineFileDownload } from "react-icons/md";

const BulkRegistration = () => {
  const { userRoleDetails } = React.useContext(AppContext);
  const { addToast } = useToasts();
  const token = localStorage.getItem("access_token");
  const client = useClient();
  client.config.headers = { Authorization: `JWT ${token}` };

  const [initialDataLoaded, setInitialDataLoaded] = React.useState(false);
  const { profileQuotaExceeded, profileInfoLoading } = useCheckProfileQuota();
  const [pageName, setPageName] = useState("Bulk Registration");
  const [isLoading, setIsLoading] = useState(false);
  const [csvCount, setCsvCount] = useState(false);
  const [csvRequestID, setCsvRequestID] = useState(null);
  const [showResponse, setShowResponse] = useState(false);
  const [responseMessage, setShowResponseMessage] = useState("");
  const [isError, setIsError] = useState("");
  const [isMiscError, setIsMiscError] = useState([]);
  const [uploadResponse, setUploadResponse] = useState("");
  const [currPageNumber, setCurrentPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // useEffect(() => {
  //   if (!userRoleDetails?.menuItems) return;
  //   setPageName(
  //     userRoleDetails?.menuItems["bulk-registration"]?.children[
  //       personRegistryType
  //     ]?.name ?? ""
  //   );
  // }, [pathname, userRoleDetails, personRegistryType, setPageName]);

  const handlePageChange = (page) => {
    setCurrentPageNumber(page);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
  };

  const registeredFiles = useQuery(
    [
      apiRoutes.bulkRegistrationRegister,
      {
        page: {
          number: currPageNumber,
          size: pageSize,
        },
      },
    ],
    { client }
  );

  React.useEffect(() => {
    if (registeredFiles?.isFetching && !registeredFiles?.isLoading) {
      setInitialDataLoaded(false);
    } else {
      setInitialDataLoaded(true);
    }
  }, [registeredFiles]);

  const [files, setfiles] = useState(null);
  const [over, setover] = useState(false);
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const formatBulkError = (errorText = "") => {
    const minSplitRowSize = 4;
    let rowSize = 4;
    const [errorDetail, errotMiscDetailString] = _.split(errorText, ":");
    const errorMiscDetail = _.split(errotMiscDetailString, ",").map((val) =>
      val.trim()
    );
    if (errorMiscDetail?.length > minSplitRowSize)
      rowSize = _.ceil(errorMiscDetail.length / 2);
    return {
      detail: `${errorDetail.trim()}${errorMiscDetail?.length ? " :" : ""}`,
      miscDetails: _.chunk(errorMiscDetail, rowSize) ?? [],
    };
  };

  const pluralFormatting = (word, count) => (count > 1 ? word + "s" : word);

  const handleDrop = (event) => {
    setIsLoading(true);
    event.preventDefault();
    const droppedFiles = event?.target?.files
      ? event?.target?.files
      : event.dataTransfer.files;
    const file = droppedFiles[0];
    const fileName = file.name;
    const fileExtension = fileName.split(".").pop().toLowerCase();

    if (fileExtension !== "csv") {
      setIsError("The uploaded file is not a CSV.");
      setIsMiscError(null);
      setIsLoading(false);
      return;
    } else {
      const formData = new FormData();
      formData.append("csv_file", file);
      axios
        .post(`${apiRoutes.bulkRegistrationUpload}`, formData, {
          headers: {
            Authorization: `JWT ${token}`,
            "content-type": "multipart/form-data",
          },
        })
        .then((response) => {
          setIsLoading(false);
          let personCount = response?.data?.data?.attributes;
          if (personCount.employeesCount > 0 && personCount.visitorsCount > 0) {
            setUploadResponse(
              `Click on proceed to add ${
                personCount.employeesCount
              } ${pluralFormatting(
                "employee",
                personCount.employeesCount
              )} and ${personCount.visitorsCount} ${pluralFormatting(
                "visitor",
                personCount.visitorsCount
              )}`
            );
          } else if (personCount.employeesCount > 0) {
            setUploadResponse(
              `Click on proceed to add ${
                personCount.employeesCount
              } ${pluralFormatting("employee", personCount.employeesCount)}`
            );
          } else if (personCount.visitorsCount > 0) {
            setUploadResponse(
              `Click on proceed to add ${
                personCount.visitorsCount
              } ${pluralFormatting("visitor", personCount.visitorsCount)}`
            );
          } else {
            setIsError(
              "There is no employee or visitor data present in the csv."
            );
          }
          setCsvCount(true);
          setCsvRequestID(personCount?.requestId);
        })
        .catch((error) => {
          setIsLoading(false);
          if (!error?.response?.data?.errors) {
            addToast(DISPLAY_TEXTS.BULK_REGISTRATION_UPLOAD_FAILED, {
              appearance: "error",
            });
            return;
          }
          const { detail: errotDetail, miscDetails: errorMiscDetails } =
            formatBulkError(error?.response?.data?.errors?.[0]?.detail);
          setIsError(errotDetail);
          setIsMiscError(errorMiscDetails);
        });
    }
  };

  const handleDataSubmit = (isProceed = false) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("requestId", csvRequestID);
    formData.append("auth", isProceed ? "1" : "0");
    axios
      .post(`${API_BASE_URL}${apiRoutes.bulkRegistrationRegister}`, formData, {
        headers: {
          Authorization: `JWT ${token}`,
          "content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        setShowResponse(true);
        setShowResponseMessage(res?.data?.data?.message);
        registeredFiles?.refetch && registeredFiles.refetch();
      })
      .catch((err) => {
        setShowResponse(true);
        setIsError(
          `Bulk profile registration failed!\n${
            err?.response?.data?.errors[0]?.detail ?? ""
          }`
        );
      })
      .finally(() => {
        setCsvCount(false);
        setIsLoading(false);
        setCsvRequestID(null);
      });
  };

  const handleSuccess = () => {
    setShowResponse(false);
    setShowResponseMessage("");
  };

  const handleError = () => {
    setShowResponse(false);
    setIsError("");
  };

  const renderProfileCard = (data) => (
    <ProfileCard
      data={data}
      mode="bulk-registration"
      actions={userRoleDetails}
      actionsToParent={(mode) => getEvent({ mode, invite })}
      // getStatusLabel={getStatusLabel}
      fields={[
        {
          name: "Date",
          value: getFormattedDateTime(data?.created),
        },
        {
          name: "File",
          value: data?.fileUrl ? (
            <a className="file-link" href={data.fileUrl}>
              {formatTextWithFallback(data?.fileName)}
            </a>
          ) : (
            formatTextWithFallback(data?.fileName)
          ),
        },
        {
          name: "profile",
          value: `${formatTextWithFallback(
            data?.createdProfiles
          )}/${formatTextWithFallback(data?.totalProfiles)}`,
        },
        {
          name: "Status",
          value: _.startCase(data?.status),
        },
      ]}
    />
  );

  const csvTableColumns = [
    {
      name: "Date",
      minWidth: 250,
      cell: (data) => renderProfileCard(data),
    },

    {
      name: "File",
      selector: (row) => {
        if (row?.fileUrl) {
          return (
            <a className="file-link" href={row.fileUrl}>
              {formatTextWithFallback(row?.fileName)}
            </a>
          );
        } else {
          return formatTextWithFallback(row?.fileName);
        }
      },
      sortable: true,
      minWidth: 250,
      hide: "md",
    },
    {
      name: "Profile",
      selector: (row) =>
        `${formatTextWithFallback(
          row?.createdProfiles
        )}/${formatTextWithFallback(row?.totalProfiles)}`,
      sortable: true,
      minWidth: 250,
      hide: "md",
    },
    {
      name: "Status",
      minWidth: 250,
      selector: (row) => (
        <div>
          {row.status ? (
            <PillText label={row?.status} type={String(row?.status)} />
          ) : (
            "--"
          )}
        </div>
      ),
      sortable: true,
      hide: "md",
    },
    {
      name: "Actions",
      sortable: false,
      maxWidth: 100,
      minWidth: 100,
      selector: (row) => row?.id,
      hide: "md",
      cell: (row) => (
        <div className="actionColumn center">
          {checkModuleGeneralPermission(
            userRoleDetails,
            "bulk-registration",
            "download_filereport",
            row
          ) && (
            <a
              data-tip="Download report"
              className="download-report-link"
              href={
                String(row?.id ?? "").length
                  ? `${apiRoutes.bulkRegistrationProfileFile}/${row.id}`
                  : "#"
              }
            >
              <BiSolidReport />
            </a>
          )}
          <ReactTooltip />
        </div>
      ),
    },
  ];

  if (profileInfoLoading) {
    return <Loader />;
  } else {
    return (
      <>
        <div className="row">
          <div className="col-12">
            <div className="page-header">
              <h1>{pageName}</h1>
            </div>
            {profileQuotaExceeded && <QuotaExceedBanner infoName="Profile" />}
          </div>
        </div>
        <div className="row">
          <div className="col-md-8 col-sm-12">
            {isLoading ? (
              <div className="card h-100 justify-content-center">
                <div className=" upload-container">
                  <span className="input-loader-container">
                    <div
                      className="spinner-border spinner-border-sm ml-1"
                      role="status"
                    ></div>
                  </span>
                </div>
              </div>
            ) : !isError ? (
              <div className="card h-100 justify-content-center">
                {!showResponse ? (
                  !csvCount ? (
                    <div
                      onDrop={(e) => {
                        e.preventDefault();
                        if (!profileQuotaExceeded) {
                          handleDrop(e);
                          setover(false);
                        }
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        setover(true);
                      }}
                      onDragLeave={(e) => {
                        if (!profileQuotaExceeded) {
                          e.preventDefault();
                          setover(false);
                        }
                      }}
                      className={
                        over ? "upload-container over" : "upload-container"
                      }
                    >
                      <span className="iconsminds-folder-add-- upload-icon mb-5 d-md-block"></span>

                      <h4 className="mb-3 d-xs-none d-sm-none d-md-block ">
                        Drop a file here to upload or{" "}
                      </h4>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        id="submitButton"
                        onClick={handleButtonClick}
                        disabled={profileQuotaExceeded}
                      >
                        Upload
                      </button>
                      <input
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        type="file"
                        onChange={(e) => {
                          handleDrop(e);
                        }}
                      />
                    </div>
                  ) : (
                    <div className="upload-container">
                      <div>
                        <h3 className="px-3">{uploadResponse}</h3>
                      </div>
                      <div className="d-flex mt-4">
                        <button
                          type="button"
                          className="btn btn-primary mr-3"
                          id="cancelButton"
                          onClick={() => {
                            handleDataSubmit(false);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          id="proceedButton"
                          onClick={() => {
                            handleDataSubmit(true);
                          }}
                        >
                          Proceed
                        </button>
                      </div>
                    </div>
                  )
                ) : (
                  <div className="upload-container">
                    <div>
                      <h3 className="px-3">{responseMessage}</h3>
                    </div>
                    <button
                      type="button"
                      className="btn btn-secondary mt-4"
                      id="proceedButton"
                      onClick={handleSuccess}
                    >
                      OK
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="upload-container">
                <h3 className={`px-3 ${isMiscError?.length > 0 ? "mb-3" : ""}`}>
                  {isError}
                </h3>
                {isMiscError?.length > 0 && (
                  <div className="d-flex justify-content-around">
                    {isMiscError[0]?.length && (
                      <ul className="pl-0">
                        {isMiscError[0]?.map((errorItem) => (
                          <li>{errorItem}</li>
                        ))}
                      </ul>
                    )}
                    {isMiscError[1]?.length && (
                      <ul>
                        {isMiscError[1]?.map((errorItem) => (
                          <li>{errorItem}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
                <button
                  type="button"
                  className="btn btn-secondary mt-4"
                  id="proceedButton"
                  onClick={handleError}
                >
                  OK
                </button>
              </div>
            )}
          </div>
          <div className="col-md-4 col-sm-12 template-section">
            <div className="card d-flex align-items-center h-100">
              <div className="upload-instructions">
                <h3 className="mt-5 ps-2 pe-1">
                  Follow the instructions below while uploading CSV
                </h3>
                <ul>
                  <li className="mt-3">
                    Structure your CSV file correctly to ensure proper use.
                  </li>
                  <li>
                    Each column should represent a different field (e.g., Name,
                    ID type, Email, Nationality).
                  </li>
                  <li>
                    Similarly, Each row should correspond to entry, containing
                    the data specific to each field for that particular record.
                  </li>
                  <li>
                    Adhering to the template provided below will help ensuring
                    that your CSV file maintains the correct structure and
                    format.
                  </li>
                  <li>
                    If <b>FIN</b> is entered as the ID during data entry, the{" "}
                    <b>Work Permit Expiry</b> field must be filled out.
                  </li>
                  <li>
                    You can get the sample <b>Template</b> and <b>Trade</b> list
                    by clicking on the options below.
                  </li>
                </ul>
              </div>
              <div className="d-flex mb-4 mt-3">
                <a
                  href={TemplateCsv}
                  download="bulk_registration_template.csv"
                  target="_blank"
                >
                  <button
                    type="button"
                    className="btn btn-secondary d-flex justify-content-between align-items-center"
                  >
                    Template
                    <MdOutlineFileDownload
                      className="ml-1 "
                      fontSize={"1.2em"}
                    />
                  </button>
                </a>
                <a href={`${apiRoutes.tradeList}`} download="trades_list.csv">
                  <button
                    type="button"
                    className="btn btn-secondary ml-3 d-flex justify-content-between align-items-center"
                  >
                    Trade List
                    <MdOutlineFileDownload
                      className="ml-1"
                      fontSize={"1.2em"}
                    />
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-md-12 mt-5">
            <div className="card">
              <div
                className={
                  registeredFiles?.isLoading ||
                  registeredFiles?.isFetching ||
                  !initialDataLoaded
                    ? "card-body dataTableOuter table-loader"
                    : "card-body dataTableOuter"
                }
              >
                <DataTable
                  className="no-radius"
                  keyField="id"
                  progressPending={
                    registeredFiles?.isLoading ||
                    registeredFiles?.isFetching ||
                    !initialDataLoaded
                  }
                  progressComponent={<p>&nbsp;</p>}
                  columns={csvTableColumns}
                  data={registeredFiles?.data}
                  striped={true}
                  pagination={true}
                  paginationServer={true}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePageSizeChange}
                  paginationPerPage={pageSize}
                  paginationTotalRows={registeredFiles?.meta?.pagination.count}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default BulkRegistration;
